
import { Component, Vue, Prop } from "vue-property-decorator";
import { IOrder } from "./IOrder";
import { Tree } from "@/tree/Tree";
import Bus from "@/lib/Bus"; const bus: Bus = new Bus().getBus(); 
import OrderVue from "@/order/Order.vue";
import  ButtonVue from "@/lib/Button.vue";
import  ClipUseVue from "@/clip/ClipUse.vue";
import  ClipAddVue from "@/clip/ClipAdd.vue";
import  ClipUseMultiVue from "@/clip/ClipUseMulti.vue";
import  ClipAddMultiVue from "@/clip/ClipAddMulti.vue";
import { OrderSvc } from "./OrderSvc"

import { Next, Route } from 'vue-router';
import { ISelector } from "@/selector/ISelector";

class OrdersSelector implements ISelector {
    limit:number=99
    type:string="order"
    projection={ numer_etykiety_erp:1, numer_etykiety_u_odbiorcy:1, identyfikator_odbiorcy:1, data_dokumentu:1, data_odbioru:1, zamodb_idm:1 }



    filter={ parent_id:undefined, lbl_id: undefined, prj_id:undefined}
    sort= {_id: -1}
}

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<OrdersVue>) {
            console.log("beforeRouteEnter:", to.path)
            next((vm: OrdersVue) => {  });
        },
        components: { OrdersVue,  ButtonVue, ClipUseVue, ClipAddVue, ClipUseMultiVue, ClipAddMultiVue } 
})
export default class OrdersVue extends Vue {

  lbl_idn:string="";
  orders:IOrder[] = []
  limit:number=99
  selector:ISelector = new OrdersSelector();

  key=1;

  async mounted() {
    console.log('mounted ',this.$route.params)
    this.selector.filter.parent_id = this.$route.params.lbl_id
    this.selector.filter.lbl_id = undefined
    this.selector.filter.prj_id = this.$route.params.prj_id

    await this.refresh();
  }


  async refresh() {
    this.orders=  await new OrderSvc().get_orders(this.selector)
    this.key++
  }

  async show_order(_id:string) {
    window.router.push({ path: `/zlecenia/${_id}` }) 
  }

}
